module.exports = __webpack_public_path__ + "img/rule-bg.8054e225.png";